import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar } from '@material-ui/core';
import Logo from '../../../../images/logo.png'

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  },
  NavColor: {
    color: '#F8679C'
  }
}));

const Topbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root,classes.NavColor, className)}
      color="primary"
    >
      <Toolbar>
        <RouterLink to="/">
        <img
            alt="Logo"
            src={Logo}
            height="50px"
          />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
